
export const deviceConstants = {
  GetAllDevicesRequest : "GET_ALL_DEVICES_REQUEST",
  GetAllDevicesFailure : "GET_ALL_DEVICES_FAILURE",
  GetAllDevicesSuccess : "GET_ALL_DEVICES_SUCCESS",

  AssignDeviceToFieldRequest: "ASSIGN_DEVICE_TO_FIELD_REQUEST",
  AssignDeviceToFieldFailure: "ASSIGN_DEVICE_TO_FIELD_FAILURE",
  AssignDeviceToFieldSuccess: "ASSIGN_DEVICE_TO_FIELD_SUCCESS",
  AssignDeviceToFieldClear: 'ASSIGN_DEVICE_TO_FIELD_CLEAR',

  UpdateCredentialsRequest: "UPDATE_CREDENTIALS_REQUEST",
  UpdateCredentialsFailure: "UPDATE_CREDENTIALS_FAILURE",
  UpdateCredentialsSuccess: "UPDATE_CREDENTIALS_SUCCESS",
  UpdateCredentialsClear: "UPDATE_CREDENTIALS_CLEAR"
}